import React from 'react';
import { Button, Modal } from '@ver-uds/react';
import { Alert, ButtonGroup } from '@ver-uds/uswds-react';
import ErrorConstants from '../../constants/ErrorConstants';
import { AlertType, RejectEnrollmentModalData } from './ManageCompaniesResultsModalData';

export interface RejectEnrollmentModalProps {
  open: boolean;
  companyData?: RejectEnrollmentModalData;
  modalAlert?: AlertType;
  onClose: () => void;
  refetch: () => void;
  onSubmit: () => void;
}

export const RejectEnrollmentModal = ({
  open,
  companyData,
  modalAlert,
  onClose,
  refetch,
  onSubmit,
}: RejectEnrollmentModalProps): JSX.Element => {
  const renderModalContent = (): JSX.Element => {
    return (
      <>
        <Modal.Content>
          <p>Are you sure you want to reject {companyData?.companyName}?</p>
        </Modal.Content>
        <Modal.Footer className="display-flex flex-row flex-justify-end">
          <ButtonGroup>
            <Button variant="secondary" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="destructive" type="button" onClick={onSubmit}>
              Reject Enrollment
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </>
    );
  };
  const renderModalAlert = (): JSX.Element => {
    switch (modalAlert) {
      case AlertType.ERROR:
        return (
          <Alert status="error" slim>
            <Alert.Text>{ErrorConstants.REJECT_ENROLLMENT_ERROR}</Alert.Text>
          </Alert>
        );
      case AlertType.SUCCESS:
        return (
          <Alert status="success" slim>
            <Alert.Text>The enrollment for {companyData?.companyName} was rejected successfully.</Alert.Text>
          </Alert>
        );
      default:
        return <></>;
    }
  };

  const renderOnClose = (): (() => void) => {
    return modalAlert !== undefined && modalAlert === AlertType.SUCCESS
      ? () => {
          onClose();
          refetch();
        }
      : () => onClose();
  };

  return (
    <Modal header="Reject Client Enrollment" id="reject-enrollment-modal" open={open} close={renderOnClose()}>
      {modalAlert !== undefined ? renderModalAlert() : renderModalContent()}
    </Modal>
  );
};

export default RejectEnrollmentModal;
